import type { ILogging } from '../../../api/types/ILogging';
import type { UnknownObject } from '../../../types';
import { getAblyOnlyLog } from '../../getAblyOnlyLog/getAblyOnlyLog';

/**
 * logging 객체에서 analytics, ably_only_log를 추출하고
 * 추가 analytics, ably_only_log를 머지합니다.
 */
export function mergeLogging({
  logging,
  analytics,
  ably_only_log,
}: {
  logging?: ILogging;
  analytics?: UnknownObject;
  ably_only_log?: UnknownObject;
}): ILogging {
  if (logging == null) {
    return { analytics, ably_only_log };
  }

  return {
    analytics:
      analytics != null
        ? { ...logging.analytics, ...analytics }
        : logging.analytics,
    ably_only_log:
      ably_only_log != null
        ? { ...getAblyOnlyLog(logging), ...ably_only_log }
        : getAblyOnlyLog(logging),
  };
}
